/**
 * attachmentChunkStore: chunk path.
 *
 * The one place the chunk object's Storage path is spelled. Contract surface —
 * the version callables, the sweep, the web reader and the rules tests all name
 * this path — and content-addressed by construction: `digest` is the manifest
 * entry's `h`, the sha256 of the uncompressed chunk bytes.
 */

/** Storage path of one chunk: `attachments/{fileUid}/chunks/{digest}`. */
export const attachmentChunkPath = (fileUid: string, digest: string): string =>
  `attachments/${fileUid}/chunks/${digest}`;
